import { styled } from "@mui/material";
import Box from "@mui/material/Box";

const Row = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    display: "grid",
    gridAutoColumns: "minmax(0, 1fr)",
    gridAutoFlow: "column",
    gap: 2,
    [theme.breakpoints.down("md")]: {
      gridAutoFlow: "row",
    },
  })
);

export default Row;
